import axios from "axios";
import React, { useEffect, useState } from "react";
import Masonry from "react-masonry-css";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const Gallary = () => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(true);

  // Load API
  useEffect(() => {
    axios
      .get("https://admin.tulikaarts.in/api/gallery")
      .then((res) => {
        setGalleryImages(res.data?.data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  // Fancybox minimal UI
  useEffect(() => {
    if (!loading) {
      Fancybox.bind("[data-fancybox='gallery']", {
        Thumbs: false,
        Toolbar: { display: ["close"] },
        Carousel: { Navigation: false },
      });
    }
    return () => Fancybox.destroy();
  }, [loading]);

  const breakpointColumnsObj = {
    default: 4,
    1100: 3,
    700: 2,
    500: 1,
  };

  return (
    <section className="gallery py-5">
      <div className="container">
        <h2 className="text-center mt-9">Art Gallery</h2>

        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {/* Show skeleton while loading */}
          {loading &&
            [...Array(8)].map((_, i) => (
              <div className="gallery-skeleton mb-4" key={i}></div>
            ))}

          {/* After loading */}
          {!loading &&
            galleryImages.map((image) => {
              const imgUrl = image.gallery_image_url;

              return (
                <a
                  key={image.id}
                  data-fancybox="gallery"
                  href={imgUrl}
                  className="painting mb-4 block overflow-hidden"
                >
                  <img
                    src={imgUrl}
                    alt="Gallery"
                    loading="lazy"
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      opacity: 0,
                      transform: "scale(0.98)",
                      transition: "opacity .6s ease, transform .6s ease",
                    }}
                    onLoad={(e) => {
                      e.currentTarget.style.opacity = 1;
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                  />
                </a>
              );
            })}
        </Masonry>
      </div>
    </section>
  );
};

export default Gallary;
